import api from './api';

export interface LlmProvider {
  id: string;
  nome: string;
  url: string;
  model: string;
  apiKey?: string | null;
  tipo: string;
  ativo: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LlmProviderInput {
  nome: string;
  url: string;
  model: string;
  apiKey?: string | null;
  tipo?: string;
  ativo?: boolean;
}

export interface AtivoEfetivo {
  fonte: 'banco' | 'env';
  provider: {
    id: string | null;
    nome: string;
    url: string;
    model: string;
    apiKey?: string | null;
    tipo: string;
    ativo: boolean;
  } | null;
}

export const llmProviderService = {
  async list(): Promise<LlmProvider[]> {
    const response = await api.get<LlmProvider[]>('/llm-providers');
    return response.data;
  },

  async ativo(): Promise<AtivoEfetivo> {
    const response = await api.get<AtivoEfetivo>('/llm-providers/ativo');
    return response.data;
  },

  async create(data: LlmProviderInput): Promise<LlmProvider> {
    const response = await api.post<LlmProvider>('/llm-providers', data);
    return response.data;
  },

  async update(id: string, data: Partial<LlmProviderInput>): Promise<LlmProvider> {
    const response = await api.put<LlmProvider>(`/llm-providers/${id}`, data);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/llm-providers/${id}`);
  },

  async setAtivo(id: string): Promise<LlmProvider> {
    const response = await api.post<LlmProvider>(`/llm-providers/${id}/ativar`);
    return response.data;
  },

  async test(id: string): Promise<{ ok: boolean; message?: string; model?: string; erro?: string }> {
    const response = await api.post(`/llm-providers/${id}/test`);
    return response.data;
  },
};
